import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '@/features/tenant/pages/settings-layout';

export const Route = createFileRoute('/_app/settings')({ component: SettingsLayout });
